<ng-container *ngIf="!verification; else verificationTemplate">
	<form (ngSubmit)="login()" [formGroup]="personalNumberForm">
		<div class="obg-m-smart-id-login-form-content">
			<mat-form-field>
				<input
					matInput
					type="tel"
					formControlName="personalNumber"
					test-id="personal-number"
					data-test-id="personal-number"
					placeholder="{{ 'smart-id-login.personal-number.label' | translate }}"
					maxlength="13"
					required
					(blur)="gtmEventAction('SmartID')"
				/>
			</mat-form-field>
			<div class="obg-m-smart-id-login-form-messages">
				<obg-common-validation-renderer
					[input]="personalNumberForm.controls.personalNumber"
					translationPrefix="smart-id-login.personal-number"
				>
				</obg-common-validation-renderer>
				<label
					test-id="help-text"
					class="obg-m-smart-id-login-form-pno-help"
					[innerHtml]="'smart-id-login.personal-number.help' | translate"
				>
				</label>
			</div>
		</div>
		<div class="obg-m-smart-id-login-form-actions">
			<mat-slide-toggle
				formControlName="shouldRememberUser"
				test-id="login-should-remember-user"
				color="primary"
				(change)="gtmEventAction('RememberMe')"
				>{{ 'login.rememberEmail.placeholder' | translate }}
			</mat-slide-toggle>
			<div
				*ngIf="errorMessage && showError"
				class="validation-error"
				[attr.test-id]="errorMessage"
				[attr.data-test-id]="errorMessage"
			>
				{{ errorMessage | translate }}
			</div>
			<button
				[disabled]="isLoading"
				mat-flat-button
				color="accent"
				class="primary-button"
				test-id="login-submit"
				data-test-id="login-submit"
			>
				<span *ngIf="!isLoading; else loading">{{ 'smart-id-login.submit' | translate }}</span>
				<ng-template #loading>
					<mat-spinner diameter="20"></mat-spinner>
				</ng-template>
			</button>
		</div>
	</form>
</ng-container>

<ng-template #verificationTemplate>
	<obg-m-smart-id-login-verification-container></obg-m-smart-id-login-verification-container>
</ng-template>
